import { useIconColors } from './use-icon-colors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const GaugeChartIcon = ({
  size = 25
}) => {
  const colors = useIconColors();
  if (!colors) {
    return /*#__PURE__*/_jsx("div", {});
  }
  const {
    orange,
    purple
  } = colors;
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsxs("svg", {
      width: size,
      height: size,
      viewBox: "0 0 80 80",
      children: [/*#__PURE__*/_jsx("path", {
        fill: "none",
        stroke: orange,
        strokeWidth: "15",
        d: "M 8.5 58 C 9 13 71.5 14 71.5 58"
      }), /*#__PURE__*/_jsx("path", {
        fill: "none",
        stroke: purple,
        strokeWidth: "11",
        d: "M 65 17 L 45 42"
      })]
    })
  });
};
export default GaugeChartIcon;